<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>

<app-loader *ngIf="isLoading()"></app-loader>
